export default "__VITE_ASSET__BRxUQsjs__"